/* AZMARA - Mobile-Fix (Notbehelf, nur fuer die Test-Kopie)
   Entfernt NUR die Zeile "display: grid !important" aus der Regel ".header__search *"
   (theme.css, nur Handy). Diese Regel stapelt sonst das Such-Fenster.
   Kann entfallen, sobald diese eine Zeile direkt in assets/theme.css geloescht ist. */
(function () {
  function patch(rules) {
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      if (r.type === 1) {
        if (r.selectorText === '.header__search *' && r.style && r.style.getPropertyValue('display') === 'grid') {
          r.style.removeProperty('display');
        }
      } else if (r.cssRules) {
        try { patch(r.cssRules); } catch (e) {}
      }
    }
  }
  function run() {
    for (var s = 0; s < document.styleSheets.length; s++) {
      try { patch(document.styleSheets[s].cssRules); } catch (e) {}
    }
  }
  run();
  window.addEventListener('load', run);

  /* X in die Eingabezeile (neben die Lupe) setzen - Handy und PC */
  function placeX() {
    var field = document.querySelector('.search-modal form .field');
    var btn = document.querySelector('.search-modal__close-button');
    var lupe = field && field.querySelector('.search__button');
    if (!field || !btn || !lupe) return;
    if (btn.parentNode !== field) field.insertBefore(btn, lupe);
    field.classList.add('az-x-moved');
    var root = field.closest('predictive-search');
    if (root) root.classList.add('az-x-root');
  }
  placeX();
  window.addEventListener('load', placeX);

  /* X im Such-Fenster: steht Text im Feld, wird nur der Text geloescht;
     ist das Feld leer, schliesst das X das Such-Fenster wie bisher. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.search-modal__close-button');
    if (!btn) return;
    var input = document.getElementById('Search-In-Modal');
    if (input && input.value) {
      e.preventDefault();
      e.stopImmediatePropagation();
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    }
  }, true);
})();
